import { render, staticRenderFns } from "./Crumb.vue?vue&type=template&id=f24e7698&scoped=true&"
import script from "./Crumb.vue?vue&type=script&lang=js&"
export * from "./Crumb.vue?vue&type=script&lang=js&"
import style0 from "./Crumb.vue?vue&type=style&index=0&id=f24e7698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24e7698",
  null
  
)

export default component.exports